// src/api/apiService.ts
import axios, { AxiosInstance } from 'axios'; // Assicurati di aver installato Axios: npm install axios
import Swal from 'sweetalert2'
import store, { ActionTypes } from '../store'; // Assicurati che il percorso sia corretto

//  baseURL: 'http://orlando-api-dev.rasottoflotte.it:85/api',
// baseURL: 'https://orlando-api-dev.rasottoflotte.it:2083/api',


/**
 * Servizio per gestire le chiamate API di autenticazione
 */
class ApiService {
    private api: AxiosInstance;

    constructor() {
        // Imposta l'URL base delle tue API Laravel

        let apiUrl;
        if (import.meta.env.VITE_DEBUG === 'true') {
            apiUrl = import.meta.env.VITE_API_RASOTOT_URL_DEBUG;
        } else {
            apiUrl = import.meta.env.VITE_API_RASOTOT_URL;
        }

        this.api = axios.create({
            baseURL: apiUrl,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            timeout: 40000 // Timeout aumentato a 120 secondi (2 minuti)
        });

        // Configura axios-retry per gestire errori di rete e timeout
        /*    axiosRetry(this.api, {
               retries: 3, // Numero di tentativi aumentato a 3
               retryDelay: (retryCount) => {
                   // Delay progressivo: 2s, 4s, 6s
                   return retryCount * 2000;
               },
               retryCondition: (error: any) => {
                   // Riprova su errori di rete, timeout o errori 5xx del server
                   const isNetworkError = axiosRetry.isNetworkOrIdempotentRequestError(error);
                   const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
                   const isServerError = error.response && error.response.status >= 500;
                   
                   return isNetworkError || isTimeout || isServerError;
               },
               onRetry: (retryCount: number, error: any, requestConfig: AxiosRequestConfig) => {
                   console.warn(`[API Retry ${retryCount}/3] ${requestConfig.url}`, {
                       error: error.message,
                       code: error.code
                   });
                   
                   // Mostra messaggio solo al primo retry
                   if (retryCount === 1) {
                       const toast = Swal.mixin({
                           toast: true,
                           position: 'top-end',
                           showConfirmButton: false,
                           timer: 2000,
                           timerProgressBar: true
                       });
                       
                       toast.fire({
                           icon: 'info',
                           title: 'Connessione lenta, riprovo...'
                       });
                   }
               }
           }); */

        // Interceptor per aggiungere il token ad ogni richiesta
        this.api.interceptors.request.use((config) => {
            const token = localStorage.getItem('authToken');
            if (token && config.headers) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            // Controlla se i dati della richiesta sono un'istanza di FormData
            if (config.data instanceof FormData) {
                // Se lo sono, rimuovi l'header 'Content-Type'
                // per permettere al browser di impostare 'multipart/form-data'
                // e il 'boundary' corretto.
                delete config.headers['Content-Type'];
            }

            return config;
        });

        // Interceptor per gestire errori in modo centralizzato
        this.api.interceptors.response.use(
            (response) => response,
            (error) => {
                // Gestione degli errori di timeout
                if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                    console.error('[API Timeout]', {
                        url: error.config?.url,
                        timeout: error.config?.timeout,
                        message: error.message
                    });

                    // Non mostrare Swal se è in corso un retry o se la chiamata è silenziosa
                    if (!error.config?.__isRetryRequest && !error.config?.silent) {
                        Swal.fire({
                            title: 'Connessione lenta',
                            html: `L'operazione sta richiedendo più tempo del previsto.<br/><br/>
                                   <b>Possibili cause:</b><br/>
                                   • Connessione internet instabile<br/>
                                   • Server temporaneamente sovraccarico<br/>
                                   • Elaborazione dati complessa in corso<br/><br/>
                                   <i>Riprova tra qualche istante</i>`,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            timer: 10000,
                            timerProgressBar: true
                        });
                    }

                    // Crea un errore custom per il logging
                    const customError = new Error(`Timeout dopo ${error.config?.timeout}ms: ${error.config?.url}`);
                    customError.name = 'ApiTimeoutError';
                    return Promise.reject(customError);
                }

                // Gestione errori di rete generici
                if (!error.response && error.message === 'Network Error') {
                    console.error('[API Network Error]', {
                        url: error.config?.url,
                        message: error.message
                    });

                    if (!error.config?.__isRetryRequest && !error.config?.silent) {
                        Swal.fire({
                            title: 'Errore di connessione',
                            html: `Impossibile raggiungere il server.<br/><br/>
                                   <b>Verifica:</b><br/>
                                   • La tua connessione internet<br/>
                                   • Lo stato del server<br/><br/>
                                   <i>Riprova tra qualche istante</i>`,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        });
                    }

                    const customError = new Error(`Network Error: ${error.config?.url}`);
                    customError.name = 'ApiNetworkError';
                    return Promise.reject(customError);
                }

                return Promise.reject(error);
            }
        );
    }




    async login(credentials: { email: any; password: any }): Promise<string> {
        try {
            const response = await this.api.post('/login', credentials);

            //const response = await axios.post(`${API_BASE_URL}/login`, credentials);
            console.log(response.data);

            return response.data; // Assumi che la risposta contenga un campo 'token'
            return "Token234324432"
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API login:', error.message);
            throw error;
        }
    }

    async checkToken(): Promise<boolean> {
        try {
            //console.log(`${API_BASE_URL}/checktoken`);
            //console.log(token);

            const response = await this.api.get('/checktoken');

            //const response = await axios.post(`${API_BASE_URL}/checktoken`, {
            //    headers: {
            //      Authorization: `Bearer ${token}`,
            //   },
            //});
            return response.status === 200; // Assumi che un 200 OK indichi un token valido
            return true;
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API check token:', error.message);
            throw error;
        }
    }


    logout(): string {
        try {
            store.dispatch(ActionTypes.LOGOUT);

            return "";
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API logout:', error.message);
            throw error;
        }
    }

    // COMMESSA
    async fetchCommessaByNumeroOrTarga(numero: string): Promise<any> {
        try {

            const responseCommessaNumero = await this.api.get(`commesse/${numero}`);
            const responseCommessaTarga = await this.api.get(`commesse`, {
                params: {
                    AutomezzoTarga: numero,
                    commessaAperta: true
                }
            });

            console.log(responseCommessaNumero.data);
            console.log(responseCommessaTarga.data);

            const listaUnificata = [];
            if (responseCommessaNumero.data?.data?.numero) {
                //listaUnificata.push({numero:responseCommessaNumero.data.data.numero, praticaAperta:responseCommessaNumero.data.data.praticaAperta, officinaLavoroDescrizione:responseCommessaNumero.data.data.officinaLavoroDescrizione});
                listaUnificata.push(responseCommessaNumero.data.data);
            }

            if (Array.isArray(responseCommessaTarga.data.data)) {
                listaUnificata.push(
                    ...responseCommessaTarga.data.data
                    /*      ... responseCommessaTarga.data.data.map(c => ({
                           numero: c.numero,
                           praticaAperta: c.praticaAperta,
                           officinaLavoroDescrizione: c.officinaLavoroDescrizione
                         })) */
                );
            }
            console.log(listaUnificata);


            return listaUnificata;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API fetchCommessa:', error.message);
            throw error;
        }
    }

    async commessaGet(numero: string): Promise<any> {
        try {

            const responseCommessaNumero = await this.api.get(`commesse/${numero}`);
            return responseCommessaNumero.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaGet:', error.message);
            throw error;
        }
    }

    /**
     * Elenco degli appuntamenti agenda collegati alla commessa.
     * app_mult 0 = principale (ripianificabile, non cancellabile), 1 = aggiuntivo.
     */
    async commessaAgendaGet(numero: string | number): Promise<any[]> {
        try {
            const response = await this.api.get(`commesse/${numero}/agenda`);
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaAgendaGet:', error.message);
            throw error;
        }
    }

    /** Crea un appuntamento aggiuntivo (agenda_app_mult = 1) per la commessa. */
    async commessaAgendaPost(numero: string | number, body: any): Promise<any> {
        try {
            const response = await this.api.post(`commesse/${numero}/agenda`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaAgendaPost:', error.message);
            throw error;
        }
    }

    /**
     * Aggiorna un appuntamento della commessa (slot scelto dal calendario agenda).
     * Sul principale viene ripianificata la sola data, che allinea la prenotazione
     * della commessa: la risposta la riporta nel campo `prenotazione`.
     */
    async commessaAgendaPut(numero: string | number, id: number, body: any): Promise<any> {
        try {
            const response = await this.api.put(`commesse/${numero}/agenda/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaAgendaPut:', error.message);
            throw error;
        }
    }

    /** Elimina un appuntamento aggiuntivo della commessa. */
    async commessaAgendaDelete(numero: string | number, id: number): Promise<any> {
        try {
            const response = await this.api.delete(`commesse/${numero}/agenda/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaAgendaDelete:', error.message);
            throw error;
        }
    }

    /**
     * Scarica un report PDF della commessa (con token) e lo apre in una nuova scheda.
     * @param numero   numero commessa
     * @param endpoint endpoint relativo, es: "stampa/patto-chiaro" | "stampa/ddt" | "stampa-gomme"
     */
    async apriStampaCommessa(numero: string, endpoint: string): Promise<void> {
        try {
            const response = await this.api.get(`commesse/${numero}/${endpoint}`, {
                responseType: 'blob'
            });
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // revoca ritardata: lascia al browser il tempo di aprire il PDF
                setTimeout(() => URL.revokeObjectURL(url), 60000);
        } catch (error: any) {
            let message = error?.message || 'Errore nella generazione del PDF';
            // se il server ha risposto con un errore JSON (ma responseType era blob), provo a leggerlo
            if (error?.response?.data instanceof Blob) {
                try {
                    message = JSON.parse(await error.response.data.text())?.detail || message;
                } catch { /* lascio il messaggio di default */ }
            }
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la stampa PDF commessa:', error.message);
            throw error;
        }
    }

    async commessaFasiGet(numero: string): Promise<any> {
        try {

            const responseCommessaNumero = await this.api.get(`commesse/${numero}/fase`);
            return responseCommessaNumero.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaGet:', error.message);
            throw error;
        }
    }

    async commessaUpdate(numero: string, body: any, expected?: any): Promise<any> {
        try {

            const payload = expected ? { ...body, _expected: expected } : body;
            const responseCommessaNumero = await this.api.put(`commesse/${numero}`, payload);
            return responseCommessaNumero.data.data;
        } catch (error: any) {
            // Conflitto di concorrenza (lock ottimistico): la gestione spetta al
            // chiamante (mostra il dettaglio dei campi e propone il reload).
            if (error.response?.status === 409) {
                throw error;
            }
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaUpdate:', error.message);
            throw error;
        }
    }


    async commessaVendutoGet(numero: string): Promise<any> {
        try {

            const ret = await this.api.get(`commesse/${numero}/venduto`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaVendutoGet:', error.message);
            throw error;
        }
    }
    async commessaAcquistoGet(numero: string): Promise<any> {
        try {

            const ret = await this.api.get(`commesse/${numero}/acquisto`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaAcquistoGet:', error.message);
            throw error;
        }
    }
    async commessaElaboraAttach(numero: string, param: any): Promise<any> {
        try {

            const ret = await this.api.get(`commesse/${numero}/ai/elaboraattach`, {
                params: param
            });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaAcquistoGet:', error.message);
            throw error;
        }
    }

    

   /*  async commessaElaboraAutorizzazione(numero: string, param): Promise<any> {
        try {

            const ret = await this.api.get(`commesse/${numero}/ai/elaboraautorizzazione`, {
                params: param
            });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API elaboraautorizzazione:', error.message);
            throw error;
        }
    } */
    async elaboraddtricambiacquisto(numero: string, param: any): Promise<any> {
        try {

            const ret = await this.api.get(`commesse/${numero}/ai/elaboraddtricambiacquisto`, {
                params: param
            });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API elaboraddtricambiacquisto:', error.message);
            throw error;
        }
    }

    async targaGet(params: any): Promise<any> {
        try {

            const responsetarga = await this.api.get(`automezzi`, {
                params: params
            });
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGet:', error.message);
            throw error;
        }
    }

    async targaShow(targa: string): Promise<any> {
        try {

            const responsetarga = await this.api.get(`automezzi/${targa}`);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGet:', error.message);
            throw error;
        }
    }
    async targaPost(targa: string, body: any): Promise<any> {
        try {

            const responsetarga = await this.api.post(`automezzi/${targa}`, body);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaPost:', error.message);
            throw error;
        }
    }
    /**
     * Riallinea a Motornet i dati tecnici della targa.
     *
     * ⚠️ SERVIZIO A PAGAMENTO: consuma una ricerca targa del contratto Eurotax, la stessa
     * che serve a creare una targa nuova. Va chiamata solo dopo conferma dell'operatore.
     * Risponde con l'automezzo aggiornato, l'elenco dei campi cambiati e le ricerche
     * rimaste sul contratto.
     */
    async targaMotornetAggiorna(targa: string): Promise<any> {
        try {
            const response = await this.api.post(`automezzi/${targa}/motornet`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API targaMotornetAggiorna:', error.message);
            throw error;
        }
    }

    async targaPut(targa: string, body: any): Promise<any> {
        try {

            const responsetarga = await this.api.put(`automezzi/${targa}`, body);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaPut:', error.message);
            throw error;
        }
    }

    async depositoGomme(targa: string): Promise<any> {
        try {

            const responsetarga = await this.api.get(`automezzi/${targa}/gomme`);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API depositoGomme:', error.message);
            throw error;
        }
    }

    async depositoGommeInverti(targa: string): Promise<any> {
        try {

            const responsetarga = await this.api.get(`automezzi/${targa}/gomme/inverti`);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API depositoGommeInverti:', error.message);
            throw error;
        }
    }
    async depositoGommeUpdate(id: string, body: any): Promise<any> {
        try {

            const responsetarga = await this.api.put(`gomme/${id}`, body);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API depositoGommeUpdate:', error.message);
            throw error;
        }
    }

    // salvataggio puntuale della sola ubicazione/coupon: depositoGommeUpdate() riscrive
    // tutti i campi della scheda gomme e non e' utilizzabile per l'edit inline
    async depositoGommeUbicazioneUpdate(id: string | number, ubicazione: string | null): Promise<any> {
        try {
            const response = await this.api.put(`gomme/${id}/ubicazione`, { ubicazione_pneumatico: ubicazione });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API depositoGommeUbicazioneUpdate:', error.message);
            throw error;
        }
    }

    async notecheckGet(targa: string): Promise<any> {
        try {
            const response = await this.api.get(`automezzi/${targa}/notecheck`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API notecheckGet:', error.message);
            throw error;
        }
    }

    async notecheckAdd(targa: string, note: string): Promise<any> {
        try {
            const response = await this.api.post(`automezzi/${targa}/notecheck`, { note });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API notecheckAdd:', error.message);
            throw error;
        }
    }

    async notecheckUpdate(id: number | string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`notecheck/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API notecheckUpdate:', error.message);
            throw error;
        }
    }

    async targaGetUbicazione(targa: string): Promise<any> {
        try {

            const responsetarga = await this.api.get(`automezzi/${targa}/ubicazione`);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGetUbicazione:', error.message);
            throw error;
        }
    }

    async targaUpdateUbicazione(targa: string, ubicazione: string): Promise<any> {
        try {

            const responsetarga = await this.api.put(`automezzi/${targa}/ubicazione`, { ubicazione: ubicazione });
            return responsetarga.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGetUbicazione:', error.message);
            throw error;
        }
    }

    async targaCambioGommeList(): Promise<any> {
        try {
            const responsetarga = await this.api.get(`targacambiogomme`);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaCambioGommeList:', error.message);
            throw error;
        }
    }

    async targaCambioGommeDelete(targa: any): Promise<any> {
        try {
            const response = await this.api.delete('/targacambiogomme/' + targa);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaCambioGommeDelete:', error.message);
            throw error;
        }
    }

    async targaCambioGommeAdd(text: any): Promise<any> {
        try {
            const response = await this.api.post('/targacambiogomme', { text: text });
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaCambioGommeDelete:', error.message);
            throw error;
        }
    }

    /** Destinatari disponibili per l'invio messaggi della commessa (soggetti + organico con email/cellulari). */
    async commessaDestinatariMessaggio(numero: string | number): Promise<any[]> {
        try {
            const response = await this.api.get(`commesse/${numero}/destinatari-messaggio`);
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaDestinatariMessaggio:', error.message);
            throw error;
        }
    }

    /** Accoda l'invio di un messaggio (modello) sulla commessa. body: {modello_id, canale, destinatari[], oggetto?, testo}. */
    async commessaInviaMessaggio(numero: string | number, body: any): Promise<any> {
        try {
            const response = await this.api.post(`commesse/${numero}/invia-messaggio`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commessaInviaMessaggio:', error.message);
            throw error;
        }
    }

    async invioAutorizzazioneAdd(numero: string): Promise<any> {
        try {
            const response = await this.api.post(`/commesse/${numero}/invioautorizzazione`);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async invioAutorizzazioneDelete(numero: string, id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/commesse/${numero}/invioautorizzazione/${id}`);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tempoOfficinaAdd(numero: string, body: any): Promise<any> {
        try {
            const response = await this.api.post(`/commesse/${numero}/tempoofficina`, body);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tempoOfficinaUpdate(numero: string, id: number | string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/commesse/${numero}/tempoofficina/${id}`, body);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tempoOfficinaDelete(numero: string, id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/commesse/${numero}/tempoofficina/${id}`);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async ricambiUpdate(numero: string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/commesse/${numero}/ricambiUpdate`, body);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API ricambiUpdate:', error.message);
            throw error;
        }
    }



    async commessaPost(body: any): Promise<any> {
        try {
            const response = await this.api.post('/commesse', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaPost:', error.message);
            return null;
        }
    }


    async commessaextraPost(body: any): Promise<any> {
        try {
            const response = await this.api.post('/commessaextra', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaextraPost:', error.message);
            return null;
        }
    }

    // SEDE
    async sediGet(): Promise<any> {
        try {
            const response = await this.api.get('/sedi');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API SediGet:', error.message);
            throw error;
        }
    }


    // Parcheggi
    async parcheggiGet(sede: any = null): Promise<any> {
        try {
            const response = await this.api.get('/parcheggi', { params: { sede: sede } });
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API parcheggiGet:', error.message);
            throw error;
        }
    }
    async parcheggiAdd(param: any): Promise<any> {
        try {
            const response = await this.api.post('/parcheggi', param);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API parcheggiGet:', error.message);
            throw error;
        }
    }
    async parcheggiEdit(id: any, param: any): Promise<any> {
        try {
            const response = await this.api.put('/parcheggi/' + id, param);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API parcheggiEdit:', error.message);
            throw error;
        }
    }
    async parcheggiDelete(id: any): Promise<any> {
        try {
            const response = await this.api.delete('/parcheggi/' + id);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API parcheggiDelete:', error.message);
            throw error;
        }
    }

    // MESSAGGI MODELLI (modelli di testo per SMS / Mail)
    async messaggiModelliGet(): Promise<any> {
        try {
            const response = await this.api.get('/messaggimodelli');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API messaggiModelliGet:', error.message);
            throw error;
        }
    }

    async messaggiModelliAdd(param: any): Promise<any> {
        try {
            const response = await this.api.post('/messaggimodelli', param);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API messaggiModelliAdd:', error.message);
            throw error;
        }
    }

    async messaggiModelliUpdate(id: any, param: any): Promise<any> {
        try {
            const response = await this.api.put('/messaggimodelli/' + id, param);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API messaggiModelliUpdate:', error.message);
            throw error;
        }
    }

    async messaggiModelliDelete(id: any): Promise<any> {
        try {
            const response = await this.api.delete('/messaggimodelli/' + id);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API messaggiModelliDelete:', error.message);
            throw error;
        }
    }

    // SETTING
    async settingGet(): Promise<any> {
        try {
            const response = await this.api.get('/setting');
            console.log(response.data);

            const tagOptions = response.data.data.tags.map((item: any) => ({
                value: item.name,
                label: item.description
            }));

            console.log(response.data);


            response.data.data.tagOptions = tagOptions;
            console.log(response.data);


            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API SediGet:', error.message);
            throw error;
        }
    }


    async attachTipoAdd(param: any): Promise<any> {
        try {
            const response = await this.api.post('/attach/tag', param);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachTipoAdd:', error.message);
            throw error;
        }
    }

    async attachTipoUpdate(id: any, param: any): Promise<any> {
        try {
            const response = await this.api.put('/attach/tag/' + id, param);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachTipoUpdate:', error.message);
            throw error;
        }
    }

    async attachTipoDelete(id: any): Promise<any> {
        try {
            const response = await this.api.delete('/attach/tag/' + id);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachTipoDelete:', error.message);
            throw error;
        }
    }

    async attachTipoList(): Promise<any> {
        try {
            const response = await this.api.get('/attach/tag');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachTipoList:', error.message);
            throw error;
        }
    }

    /**
     * Carica uno o più file su Attach.
     *
     * `opzioni.silent` sopprime i popup d'errore (sia quello locale sia quello
     * dell'interceptor): serve a chi ha già un proprio "riprova" sull'anteprima, come
     * il modulo Check. `opzioni.timeout` allunga il limite: un upload da telefono su
     * rete mobile può superare i 40s di default dell'istanza axios.
     */
    async attachAdd(table: string, id: string, tag: string, body: any,
        opzioni: { silent?: boolean; timeout?: number } = {}): Promise<any> {
        try {
            const response = await this.api.post(`/attach/insert/${table}/${id}/${tag}`, body, {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: opzioni.timeout ?? 40000,
                silent: opzioni.silent ?? false,
            });
            // ritorna i record creati (array di attach), così il chiamante può tracciarne gli id
            return response.data.data;
        } catch (error: any) {
            if (!opzioni.silent) {
                const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({
                    text: message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                console.error('Errore durante la chiamata all\'API attachAdd:', error.message);
            }
            throw error;
        }
    }


    async attachDelete(id: String): Promise<any> {
        try {
            const response = await this.api.delete(`/attach/show/${id}`);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachAdd:', error.message);
            throw error;
        }
    }



    async attachList(table: string, id: string, link: boolean): Promise<any> {
        try {
            console.log("attachList");

            if (link) {
                console.log("response1");

                const response1 = await this.api.get(`/attach/listwithurl/${table}/${id}`);
                return response1.data.data;

            } else {
                console.log("response2");

                const response2 = await this.api.get(`/attach/list/${table}/${id}`);
                return response2.data.data;
            }
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachList:', error.message);
            throw error;
        }
    }


    async attachGetUrl(id: any): Promise<any> {
        try {
            console.log("attachGetUrl")

            const response = await this.api.get(`/attach/show/${id}`);
            console.log(response.data)

            return response.data;
        } catch (error: any) {
            throw error;
        }
    }

    async attachSearch(param: any): Promise<any> {
        try {
            console.log("attachSearch")

            const response = await this.api.get(`/attach/search`, {
                params: {
                    numeroPratica: param.value.numeroPratica,
                    numeroTarga: param.value.numeroTarga,
                    tipo: param.value.tipo,
                    viewTags: param.value.viewTags
                }
            });
            console.log(response.data.data)

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachSearch:', error.message);
            throw error;
        }
    }


    async attachZip(params: any): Promise<any> {
        try {
            console.log("attachZip")

            const response = await this.api.post("/attach/downloadzip", params);
            console.log(response.data)

            // Ensure the returned URL uses HTTPS to avoid mixed content issues
            let url = response.data.data;
            if (url && typeof url === 'string' && url.startsWith('http://')) {
                url = url.replace('http://', 'https://');
                console.log('URL converted to HTTPS:', url);
            }

            return url;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API attachZip:', error.message);
            throw error;
        }
    }


    async attachFetch(url: any): Promise<any> {
        try {
            console.log("attachFetch")


            const response = await this.api.get(url, {
                responseType: 'blob'
            })

            return response;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API:', error.message);
            throw error;
        }
    }

    async downloadFileCompress(attachId: string, maxBytes: number = 1 * 1024 * 1024): Promise<any> {
        try {
            const response = await this.api.post(`/attach/compress/${attachId}`, {
                maxBytes,
                maxWidth: 7680,
                maxHeight: 4320,
                startQuality: 80,
                minQuality: 30,
            });

            // Estraggo in sicurezza
            const data = response?.data?.data;
            const okInner = data?.success === true;
            const urlimage: string | undefined = data?.downloadUrl;
            const tempFileName: string | undefined = data?.tempFileName;

            // Log "safe" (non esplode se manca qualcosa)
            console.log('compress response:', response?.data);
            console.log('downloadUrl:', urlimage);

            // Controlli PRIMA di usare i campi
            if (!okInner || !urlimage) {
                const reason = (!okInner) ? 'API ha risposto success=false' : 'downloadUrl mancante';
                throw new Error(`Compressione non riuscita: ${reason}`);
            }

            // Se l'URL è pubblico "senza token", puoi anche scaricare direttamente senza refetch:
            // - metodo A (diretto): crea un <a> e punta all'URL pubblico
            // - metodo B (via fetch/axios): se vuoi creare un blob per controllare content-type, CORS, ecc.
            //
            // Metodo B (coerente con il tuo codice):
            const downloadResponse = await this.attachFetch(urlimage); // assicurati che usi { responseType: 'blob' }
            console.log('blob response:', downloadResponse?.data);

            const blob = new Blob([downloadResponse.data]);
            const downloadUrl = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = tempFileName ?? 'file';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);

            return data;

        } catch (error: any) {
            const message = error?.response?.data?.detail || error?.message || 'Errore nel download del file compresso';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore download file compresso:', error);
            throw error;
        }
    }




    async activityGet(params: {
        user_name?: string | null;
        action?: string | null;
        model_type?: string | null;
        numeroPratica?: string | null;
        targa?: string | null;
        description?: string | null;
        date_from?: string | null;
        date_to?: string | null;
        count?: number | null;
    } = {}): Promise<any> {
        try {
            console.log("activityGet")


            const response = await this.api.get("/activiry", { params })

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API activityGet:', error.message);
            throw error;
        }
    }


    async activityDetailGet(id: any): Promise<any> {
        try {
            console.log("activityDetailGet")


            const response = await this.api.get("/activiry/" + id)

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API activityDetailGet:', error.message);
            throw error;
        }
    }

    // Analisi modifiche: activity_logs esploso per campo (activity_log_changes)

    async activityChangesOpzioniGet(): Promise<any> {
        try {
            const response = await this.api.get('/activity-changes/opzioni');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API activityChangesOpzioniGet:', error.message);
            throw error;
        }
    }

    async activityChangesValoriGet(modello: string | null, campi: string[]): Promise<any> {
        try {
            const response = await this.api.get('/activity-changes/valori', {
                params: { ...(modello ? { modello } : {}), campi },
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API activityChangesValoriGet:', error.message);
            throw error;
        }
    }

    async activityChangesCerca(filtri: Record<string, any>): Promise<any> {
        try {
            const response = await this.api.post('/activity-changes/cerca', filtri, { timeout: 120000 });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API activityChangesCerca:', error.message);
            throw error;
        }
    }

    async activityChangesAggiorna(): Promise<any> {
        try {
            const response = await this.api.post('/activity-changes/aggiorna', {}, { timeout: 300000 });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API activityChangesAggiorna:', error.message);
            throw error;
        }
    }

    /// REPARTI


    async listReparti(): Promise<any> {
        try {
            console.log("listReparti")


            const response = await this.api.get("/reparti")

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API listReparti:', error.message);
            throw error;
        }
    }


    /// IMPOSTAZIONI

    async impostazioniGeneraliList(): Promise<any> {
        try {
            const response = await this.api.get('/impostazioni/generali');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API impostazioniGeneraliList:', error.message);
            throw error;
        }
    }

    async impostazioniGeneraliUpdate(data: any): Promise<any> {
        try {
            const response = await this.api.put(`/impostazioni/generali/${data.id}`, data);
            console.log(response.data);

            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API impostazioniGeneraliUpdate:', error.message);
            throw error;
        }
    }

    /// RICEZIONE


    async listRicezione(): Promise<any> {
        try {
            console.log("listRicezione")


            const response = await this.api.get("/ricezione")

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API listRicezione:', error.message);
            throw error;
        }
    }

    /// TYRE


    async listOrderTyre(): Promise<any> {
        try {
            console.log("listOrderTyre")


            const response = await this.api.get("/tyre/listordertyre")

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API listOrderTyre:', error.message);
            throw error;
        }
    }

    async generaCouponTyre(body: any): Promise<any> {
        try {
            console.log("generaCouponTyre")


            // il backend attende sync del coupon e PDF delle etichette prima di rispondere:
            // può superare il timeout di default (40s)
            const response = await this.api.post("/tyre/creacoupon", body, { timeout: 120000 })

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API generaCouponTyre:', error.message);
            throw error;
        }
    }

    async stampaCouponTyre(id: any, param: any): Promise<any> {
        try {
            console.log("stampaCouponTyre")


            const response = await this.api.get("/tyre/stampacoupon/" + id, { params: param })

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API stampaCouponTyre:', error.message);
            throw error;
        }
    }

    async getCouponTyre(code: any): Promise<any> {
        try {
            console.log("getCouponTyre")


            const response = await this.api.get("/tyre/coupon/" + code)

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API getCouponTyre:', error.message);
            throw error;
        }
    }

    async getLogList(): Promise<any> {
        try {
            console.log("getCouponTyre")

            const response = await this.api.get("/logs")

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API getLogList:', error.message);
            throw error;
        }
    }

    async getLog(filename: any): Promise<any> {
        try {
            console.log("getCouponTyre")

            const response = await this.api.get("/logs/" + filename)

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API getLogList:', error.message);
            throw error;
        }
    }


    async gommeMarcaList(): Promise<any> {
        try {
            const list = await this.api.get("/tools/gommeMarca");
            return list.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API gommeMarcaList:', error.message);
            throw error;
        }
    }


    async tecniciGet(sede: any): Promise<any> {
        try {
            const response = await this.api.get('/sedi/' + sede + '/tecnici');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API tecniciGet:', error.message);
            throw error;
        }
    }

    async tecnicoGet(id: any): Promise<any> {
        try {
            const response = await this.api.get('/dipendente/' + id);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API tecnicoGet:', error.message);
            throw error;
        }
    }

    async commessaFaseUpdate(numero: any, fase: any, body: any): Promise<any> {
        try {
            const response = await this.api.put('/commesse/' + numero + '/fase/' + fase, body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaFaseUpdate:', error.message);
            throw error;
        }
    }

    async commesseInLavorazione(sedeCodice: any): Promise<any> {
        try {
            const response = await this.api.get('/commesse-in-lavorazione/' + sedeCodice);
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commesseInLavorazione:', error.message);
            throw error;
        }
    }

    async commessaFasePost(numero: any, body: any): Promise<any> {
        try {
            const response = await this.api.post('/commesse/' + numero + '/fase', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API commessaFaseUpdate:', error.message);
            throw error;
        }
    }

    async filterCommessaGet(): Promise<any> {
        try {
            const response = await this.api.get('/filter/commessa');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API filterCommessaGet:', error.message);
            throw error;
        }
    }

    // `veloce`: usa la variante senza Eloquent (search/commessa-fast), stesso formato di risposta
    async commessaSearch(body: any, veloce = false): Promise<any> {
        try {
            const response = await this.api.post(veloce ? '/search/commessa-fast' : '/search/commessa', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API filterCommessaGet:', error.message);
            throw error;
        }
    }

    async preCheckSearch(body: any): Promise<any> {
        try {
            const response = await this.api.post('/search/precheck', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API preCheckSearch:', error.message);
            throw error;
        }
    }

    async preCheckCreaCommesse(body: any): Promise<any> {
        try {
            const response = await this.api.post('/precheck/crea-commesse', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API preCheckCreaCommesse:', error.message);
            throw error;
        }
    }

    async preCheckUpdate(id: number | string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/precheck/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API preCheckUpdate:', error.message);
            throw error;
        }
    }

    async preCheckDelete(id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/precheck/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API preCheckDelete:', error.message);
            throw error;
        }
    }

    async preCheckTargheBySede(params: any): Promise<any> {
        try {
            const response = await this.api.get('/precheck/targhe', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API preCheckTargheBySede:', error.message);
            throw error;
        }
    }

    async preCheckStore(body: any): Promise<any> {
        try {
            const response = await this.api.post('/precheck', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API preCheckStore:', error.message);
            throw error;
        }
    }

    // Legge i KM dal contachilometri di una foto (vision AI). Non mostra toast in caso di
    // errore: è una comodità, il chiamante gestisce il fallback (inserimento manuale).
    async toolsEstraiKmDaImmagine(body: any): Promise<any> {
        const response = await this.api.post('/tools/kmreader', body);
        return response.data.data;
    }

    async toolsEstraiTargaDaImmagine(body: any): Promise<any> {
        try {
            const response = await this.api.post('/tools/platereader', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API toolsEstraiTargaDaImmagine:', error.message);
            throw error;
        }
    }

     async squadraEsternaGet(params=null): Promise<any> {
        try {
            const response = await this.api.get('/squadraesterna', {
                params: params
            });

            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API squadraEsternaGet:', error.message);
            throw error;
        }
    }
     async squadraEsternaShow(id: any): Promise<any> {
        try {
            const response = await this.api.get('/squadraesterna/' + id);

            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API squadraEsternaShow:', error.message);
            throw error;
        }
    }

    async clientiGet(params: any): Promise<any> {
        try {
            const response = await this.api.get('/clienti', {
                params: params
            });

            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiGet:', error.message);
            throw error;
        }
    }

    async clienteShow(codice: string): Promise<any> {
        try {
            const response = await this.api.get(`/clienti/${codice}`);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clienteShow:', error.message);
            throw error;
        }
    }

    async clienteUpdate(codice: string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/clienti/${codice}`, body);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clienteUpdate:', error.message);
            throw error;
        }
    }

    async clienteStore(body: any): Promise<any> {
        try {
            const response = await this.api.post('/clienti', body);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clienteStore:', error.message);
            throw error;
        }
    }

    async filterAgendaGet(): Promise<any> {
        try {
            const response = await this.api.get('/filter/agenda');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API filterAgendaGet:', error.message);
            throw error;
        }
    }

    async agendaSearch(body: any): Promise<any> {
        try {
            const response = await this.api.post('/search/agenda', body);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API agendaSearch:', error.message);
            throw error;
        }
    }

    async agendaWeekSummary(body: { sede: any; start_date: string; weeks?: number }): Promise<any> {
        try {
            const response = await this.api.post('/agenda/week-summary', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API agendaWeekSummary:', error.message);
            throw error;
        }
    }

    async agendaCommesseGiorno(body: { sede: any; data: string }): Promise<any> {
        try {
            const response = await this.api.post('/agenda/commesse-giorno', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API agendaCommesseGiorno:', error.message);
            throw error;
        }
    }
    async fetchDatiPartitaIva(piva: any): Promise<any> {
        try {
            const response = await this.api.post('/tools/datipartitaiva/' + piva);
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API agendaSearch:', error.message);
            throw error;
        }
    }


    async agendaChiusuraGet(params: any = null): Promise<any> {
        try {

            const responsetarga = await this.api.get(`agendachiusura`, {
                params: params
            });
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGet:', error.message);
            throw error;
        }
    }

    async agendaChiusuraPost(body: any = null): Promise<any> {
        try {

            const responsetarga = await this.api.post('/agendachiusura', body);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API agendaChiusuraPost:', error.message);
            throw error;
        }
    }

    async agendaChiusuraDelete(itemId: any): Promise<any> {
        try {

            const responsetarga = await this.api.delete('/agendachiusura/' + itemId);
            return responsetarga.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API targaGet:', error.message);
            throw error;
        }
    }

    async tabComuniGet(): Promise<any> {
        try {
            const response = await this.api.get('/tools/tabComuni');
            console.log(response.data);

            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API tabComuniGet:', error.message);
            throw error;
        }
    }

    // ==================== TRIGGER RULES ====================

    async triggersGet(params: any = {}): Promise<any> {
        try {
            const response = await this.api.get('/triggers', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersShow(id: number): Promise<any> {
        try {
            const response = await this.api.get(`/triggers/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersCreate(data: any): Promise<any> {
        try {
            const response = await this.api.post('/triggers', data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersUpdate(id: number, data: any): Promise<any> {
        try {
            const response = await this.api.put(`/triggers/${id}`, data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersDelete(id: number): Promise<any> {
        try {
            const response = await this.api.delete(`/triggers/${id}`);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersToggle(id: number): Promise<any> {
        try {
            const response = await this.api.post(`/triggers/${id}/toggle`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersDuplicate(id: number): Promise<any> {
        try {
            const response = await this.api.post(`/triggers/${id}/duplicate`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersAuditLogs(id: number | null = null, params: any = {}): Promise<any> {
        try {
            const url = id ? `/triggers/${id}/audit-logs` : '/trigger-audit-logs';
            const response = await this.api.get(url, { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggersValidate(json: string, type: 'conditions' | 'actions'): Promise<any> {
        try {
            const response = await this.api.post('/trigger-validate', { json, type });
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.message || 'JSON non valido';
            throw new Error(message);
        }
    }

    async triggersGetMeta(metaType: 'models' | 'events' | 'operators' | 'action-types'): Promise<any> {
        try {
            const response = await this.api.get(`/trigger-meta/${metaType}`);
            return response.data.data;
        } catch (error: any) {
            throw error;
        }
    }

    // Registro dei trigger (scheda "Audit log" di Impostazioni > Trigger): solo amministratori

    async triggerAuditOpzioniGet(): Promise<any> {
        try {
            const response = await this.api.get('/trigger-audit/opzioni');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggerAuditCerca(filtri: Record<string, any>): Promise<any> {
        try {
            const response = await this.api.post('/trigger-audit/cerca', filtri, { timeout: 60000 });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async triggerAuditDettaglioGet(id: number): Promise<any> {
        try {
            const response = await this.api.get(`/trigger-audit/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // ==================== CLIENTI ORGANICO ====================

    async clientiOrganicoGet(codice: string): Promise<any> {
        try {
            const response = await this.api.get(`/clienti/${codice}/organico`);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiOrganicoGet:', error.message);
            throw error;
        }
    }

    async clientiOrganicoShow(codice: string, id: number): Promise<any> {
        try {
            const response = await this.api.get(`/clienti/${codice}/organico/${id}`);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiOrganicoShow:', error.message);
            throw error;
        }
    }

    async clientiOrganicoStore(codice: string, body: any): Promise<any> {
        try {
            const response = await this.api.post(`/clienti/${codice}/organico`, body);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiOrganicoStore:', error.message);
            throw error;
        }
    }

    async clientiOrganicoUpdate(codice: string, id: number, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/clienti/${codice}/organico/${id}`, body);
            console.log(response.data);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiOrganicoUpdate:', error.message);
            throw error;
        }
    }

    async clientiOrganicoDelete(codice: string, id: number): Promise<any> {
        try {
            const response = await this.api.delete(`/clienti/${codice}/organico/${id}`);
            console.log(response.data);
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API clientiOrganicoDelete:', error.message);
            throw error;
        }
    }

    
    async jobuiGet(param: any, options: { silent?: boolean } = {}): Promise<any> {
        try {

            const ret = await this.api.get(`jobui`,{params:param, silent: options.silent});
            return ret.data.data;
        } catch (error: any) {
            if (!options.silent) {
                const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({
                    text: message,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
                console.error('Errore durante la chiamata all\'API jobuiGet:', error.message);
            }
            throw error;
        }
    }

     async terzistaGet(param: any=null): Promise<any> {
        try {

            const ret = await this.api.get(`terzista`,{params:param});
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API terzistaGet:', error.message);
            throw error;
        }
    }

    async terzistaStore(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`terzista`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API terzistaStore:', error.message);
            throw error;
        }
    }

    async terzistaUpdate(codice: string, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`terzista/${codice}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API terzistaUpdate:', error.message);
            throw error;
        }
    }

    async terzistaDelete(codice: string): Promise<any> {
        try {
            const ret = await this.api.delete(`terzista/${codice}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API terzistaDelete:', error.message);
            throw error;
        }
    }

    /* ============================================================
     *  LAVORAZIONE FASI
     * ============================================================ */
    async lavorazioneFasiGet(): Promise<any> {
        try {
            const ret = await this.api.get(`lavorazione-fasi`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiGet:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiStore(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`lavorazione-fasi`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiStore:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`lavorazione-fasi/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiUpdate:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`lavorazione-fasi/${id}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiDelete:', error.message);
            throw error;
        }
    }

    /* ============================================================
     *  ASSOCIAZIONE LAVORAZIONE FASI <-> REPARTI
     * ============================================================ */
    async lavorazioneFasiRepartoOptions(): Promise<any> {
        try {
            const ret = await this.api.get(`lavorazione-fasi-reparto/options`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiRepartoOptions:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiRepartoGet(): Promise<any> {
        try {
            const ret = await this.api.get(`lavorazione-fasi-reparto`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiRepartoGet:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiRepartoStore(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`lavorazione-fasi-reparto`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiRepartoStore:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiRepartoUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`lavorazione-fasi-reparto/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiRepartoUpdate:', error.message);
            throw error;
        }
    }

    async lavorazioneFasiRepartoDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`lavorazione-fasi-reparto/${id}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API lavorazioneFasiRepartoDelete:', error.message);
            throw error;
        }
    }

    /* ============================================================
     *  SERVIZI — catalogo (impostazioni) e associazione con gli automezzi
     * ============================================================ */
    async serviziGet(soloAttivi: boolean = false): Promise<any> {
        try {
            const ret = await this.api.get(`servizi`, { params: soloAttivi ? { attivi: 1 } : {} });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API serviziGet:', error.message);
            throw error;
        }
    }

    async serviziStore(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`servizi`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API serviziStore:', error.message);
            throw error;
        }
    }

    async serviziUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`servizi/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API serviziUpdate:', error.message);
            throw error;
        }
    }

    async serviziDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`servizi/${id}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API serviziDelete:', error.message);
            throw error;
        }
    }

    /**
     * Servizi associati alla targa.
     *
     * `soloOm` limita ai servizi con `visualizza_om` (schermata check); `silenzioso`
     * sopprime il popup di errore, come in linkentryGet, per i riquadri accessori.
     */
    async automezzoServiziGet(targa: string, soloOm: boolean = false, silenzioso: boolean = false): Promise<any> {
        try {
            const ret = await this.api.get(`automezzi/${targa}/servizi`, {
                params: soloOm ? { visualizza_om: 1 } : {},
            });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            if (!silenzioso) Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API automezzoServiziGet:', error.message);
            throw error;
        }
    }

    async automezzoServiziStore(targa: string, body: any): Promise<any> {
        try {
            const ret = await this.api.post(`automezzi/${targa}/servizi`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API automezzoServiziStore:', error.message);
            throw error;
        }
    }

    async automezzoServiziUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`automezzi-servizi/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API automezzoServiziUpdate:', error.message);
            throw error;
        }
    }

    async automezzoServiziDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`automezzi-servizi/${id}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API automezzoServiziDelete:', error.message);
            throw error;
        }
    }

    // Gestione utenti app
    async utentiAppGet(param: any = null): Promise<any> {
        try {
            const ret = await this.api.get(`utentiapp`, { params: param });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API utentiAppGet:', error.message);
            throw error;
        }
    }

    async utentiAppUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`utentiapp/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API utentiAppUpdate:', error.message);
            throw error;
        }
    }

    // Gruppi utente (contenitori di ruoli)
    async gruppiGet(param: any = null): Promise<any> {
        try {
            const ret = await this.api.get(`gruppi`, { params: param });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API gruppiGet:', error.message);
            throw error;
        }
    }

    async gruppiRolesDisponibiliGet(): Promise<any> {
        try {
            const ret = await this.api.get(`gruppi/roles-disponibili`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API gruppiRolesDisponibiliGet:', error.message);
            throw error;
        }
    }

    async gruppoCreate(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`gruppi`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API gruppoCreate:', error.message);
            throw error;
        }
    }

    async gruppoUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`gruppi/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API gruppoUpdate:', error.message);
            throw error;
        }
    }

    async gruppoDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`gruppi/${id}`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API gruppoDelete:', error.message);
            throw error;
        }
    }

    // Associazione tecnici (dipendenti) <-> filiali/sedi
    async dipendentiFilialiGet(param: any = null): Promise<any> {
        try {
            const ret = await this.api.get(`dipendenti-filiali`, { params: param });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API dipendentiFilialiGet:', error.message);
            throw error;
        }
    }

    async filialiListGet(): Promise<any> {
        try {
            const ret = await this.api.get(`dipendenti-filiali/filiali`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API filialiListGet:', error.message);
            throw error;
        }
    }

    async dipendenteFilialiUpdate(dipendenteId: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`dipendenti-filiali/${dipendenteId}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API dipendenteFilialiUpdate:', error.message);
            throw error;
        }
    }

    async dipendenteFilialiDelete(dipendenteId: number): Promise<any> {
        try {
            const ret = await this.api.delete(`dipendenti-filiali/${dipendenteId}`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' })
            console.error('Errore durante la chiamata all\'API dipendenteFilialiDelete:', error.message);
            throw error;
        }
    }

    // AI Articoli Associazione
    async aiArticoliAssociazioneGet(param: any = null): Promise<any> {
        try {
            const ret = await this.api.get(`ai-articoli-associazione`, { params: param });
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API aiArticoliAssociazioneGet:', error.message);
            throw error;
        }
    }

    async aiArticoliAssociazioneShow(id: number): Promise<any> {
        try {
            const ret = await this.api.get(`ai-articoli-associazione/${id}`);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API aiArticoliAssociazioneShow:', error.message);
            throw error;
        }
    }

    async aiArticoliAssociazioneStore(body: any): Promise<any> {
        try {
            const ret = await this.api.post(`ai-articoli-associazione`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API aiArticoliAssociazioneStore:', error.message);
            throw error;
        }
    }

    async aiArticoliAssociazioneUpdate(id: number, body: any): Promise<any> {
        try {
            const ret = await this.api.put(`ai-articoli-associazione/${id}`, body);
            return ret.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API aiArticoliAssociazioneUpdate:', error.message);
            throw error;
        }
    }

    async aiArticoliAssociazioneDelete(id: number): Promise<any> {
        try {
            const ret = await this.api.delete(`ai-articoli-associazione/${id}`);
            return ret.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({
                text: message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            console.error('Errore durante la chiamata all\'API aiArticoliAssociazioneDelete:', error.message);
            throw error;
        }
    }

    async tracklistGet(params: {
        number?: string;
        description?: string;
        count?: number;
        utilizzatore_codice?: string | number | null;
        stato?: string[];
        squadra_esterna_id?: Array<number | string> | number | string | null;
        squadra_esterna_null?: number | null;
        prenotazione_from?: string | null;
        prenotazione_to?: string | null;
        prenotazione_null?: number | null;
        targa?: string | null;
    } = {}): Promise<any> {
        try {
            const response = await this.api.get('/tracklist', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistShow(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/tracklist/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistUpdate(id: number | string, body: any): Promise<any> {
        try {
            const response = await this.api.put(`/tracklist/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistDestroy(id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/tracklist/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistRapportini(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/tracklist/${id}/rapportini`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistActivity(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/tracklist/${id}/activity`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistDetailDestroy(tracklistId: number | string, detailId: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/tracklist/${tracklistId}/details/${detailId}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistDetailUpdate(
        tracklistId: number | string,
        detailId: number | string,
        body: {
            last_stato?: 'eseguito' | 'parziale' | 'non_eseguito' | '' | null;
            note?: string | null;
            lamentato_cliente?: string | null;
            lavori_autorizzati?: string | null;
        }
    ): Promise<any> {
        try {
            const response = await this.api.put(`/tracklist/${tracklistId}/details/${detailId}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistCreate(body: { number: string; description?: string }): Promise<any> {
        try {
            const response = await this.api.post('/tracklist', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistAssociate(tracklistId: number, body: { commesse: string[] }): Promise<any> {
        try {
            const response = await this.api.post(`/tracklist/${tracklistId}/associate`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async tracklistDetailStore(tracklistId: number, numero_lavoro: string): Promise<any> {
        try {
            const response = await this.api.post(`/tracklist/${tracklistId}/details`, { numero_lavoro });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async officinaEsternaList(params: {
        prenotazione?: string;
        squadra_esterna_id?: number | string | null;
    } = {}, silent = false): Promise<any> {
        try {
            const response = await this.api.get('/tracklist/officina-esterna', { params });
            return response.data.data;
        } catch (error: any) {
            if (!silent) {
                const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            }
            throw error;
        }
    }

    async officinaEsternaShow(id: number | string, silent = false): Promise<any> {
        try {
            const response = await this.api.get(`/tracklist/officina-esterna/${id}`);
            return response.data.data;
        } catch (error: any) {
            if (!silent) {
                const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            }
            throw error;
        }
    }

    async officinaEsternaStart(id: number | string): Promise<any> {
        try {
            const response = await this.api.post(`/tracklist/officina-esterna/${id}/start`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async officinaEsternaUpdateDetail(
        tracklistId: number | string,
        detailId: number | string,
        body: { last_stato: 'eseguito' | 'parziale' | 'non_eseguito'; note?: string | null }
    ): Promise<any> {
        try {
            const response = await this.api.put(
                `/tracklist/officina-esterna/${tracklistId}/details/${detailId}/stato`,
                body
            );
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async officinaEsternaUpdateNote(
        tracklistId: number | string,
        body: { note: string | null }
    ): Promise<any> {
        try {
            const response = await this.api.put(
                `/tracklist/officina-esterna/${tracklistId}/note`,
                body
            );
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async officinaEsternaFirma(
        tracklistId: number | string,
        body: { signature: string }
    ): Promise<any> {
        try {
            const response = await this.api.post(
                `/tracklist/officina-esterna/${tracklistId}/firma`,
                body
            );
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async importTarghePost(body: {
        targhe: string | string[];
        intestatarioCodice?: number | null;
        utilizzatoreCodice?: number | null;
        locatarioCodice?: number | null;
        // codice _tabop_tipo_veicolo opzionale, scritto sull'automezzo se valorizzato
        tipoVeicoloCodice?: string | null;
        // misure pneumatici opzionali, applicate su gomme bordo + deposito
        larghezza1?: string | null;
        sezione1?: string | null;
        raggio1?: string | null;
        indice_carico1?: string | null;
        codice_velocita1?: string | null;
        larghezza2?: string | null;
        sezione2?: string | null;
        raggio2?: string | null;
        indice_carico2?: string | null;
        codice_velocita2?: string | null;
    }): Promise<any> {
        try {
            const response = await this.api.post('/import-targhe', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async importTargheGet(params: Record<string, any> = {}): Promise<any> {
        try {
            const response = await this.api.get('/import-targhe', { params });
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // Import libretti: un file per chiamata, l'errore lo gestisce il chiamante
    // (deve proseguire con i file successivi e riepilogare gli scarti alla fine).
    // Timeout ampio: con la coda sync (dev) la lettura AI avviene dentro la richiesta.
    async importLibrettiPost(file: File, opzioni: { batchId?: number | null; sostituisci?: boolean } = {}): Promise<any> {
        const fd = new FormData();
        fd.append('files[]', file);
        if (opzioni.batchId) fd.append('batch_id', String(opzioni.batchId));
        fd.append('sostituisci', opzioni.sostituisci ? '1' : '0');
        const response = await this.api.post('/import-libretti', fd, { timeout: 180000, silent: true } as any);
        return response.data.data;
    }

    async importLibrettiGet(params: Record<string, any> = {}): Promise<any> {
        try {
            const response = await this.api.get('/import-libretti', { params });
            return response.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // URL temporaneo (10 minuti) del file importato, per l'anteprima dal registro
    async importLibrettiFileUrl(id: number): Promise<{ url: string; mime_type: string }> {
        try {
            const response = await this.api.get(`/import-libretti/${id}/file`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // assegnazione manuale a una targa di un file scartato; l'errore (422) lo mostra il chiamante
    async importLibrettiAssegna(id: number, targa: string): Promise<any> {
        const response = await this.api.post(`/import-libretti/${id}/assegna`, { targa });
        return response.data.data;
    }

    async fornitoriGet(params: Record<string, any> = {}): Promise<any> {
        try {
            const response = await this.api.get('/fornitori', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async fornitoreShow(codice: string): Promise<any> {
        try {
            const response = await this.api.get(`/fornitori/${codice}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async fornitoriMittenti(tipo?: number): Promise<any> {
        try {
            const response = await this.api.get('/fornitori/mittenti', {
                params: tipo !== undefined ? { tipo } : undefined,
            });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async commessaInfoVeicolo(numero: string | number): Promise<any> {
        try {
            const response = await this.api.get(`/commesse/${numero}/info-veicolo`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async inviaOrdineFornitore(body: Record<string, any>, files: File[] = []): Promise<any> {
        try {
            let response;
            if (files && files.length) {
                const fd = new FormData();
                Object.entries(body).forEach(([k, v]) => fd.append(k, v ?? ''));
                files.forEach(f => fd.append('allegati[]', f));
                response = await this.api.post('/fornitori/invia-ordine', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
            } else {
                response = await this.api.post('/fornitori/invia-ordine', body);
            }
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async mailQueuesGet(params: Record<string, any> = {}): Promise<any> {
        try {
            const response = await this.api.get('/mailqueues', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async mailQueueShow(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/mailqueues/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async mailQueueTypes(): Promise<any> {
        try {
            const response = await this.api.get('/mailqueues/types/list');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async smsQueuesGet(params: Record<string, any> = {}): Promise<any> {
        try {
            const response = await this.api.get('/smsqueues', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async smsQueueShow(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/smsqueues/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async smsQueueTypes(): Promise<any> {
        try {
            const response = await this.api.get('/smsqueues/types/list');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Rimette in coda un SMS fallito (verrà reinviato dal worker). */
    async smsQueueResend(id: number | string): Promise<any> {
        try {
            const response = await this.api.post(`/smsqueues/${id}/resend`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // ==================== CHECK VEICOLI ====================
    // Modulo Check (sostituisce PreCheck): testata = visita del tecnico presso una sede,
    // dettaglio = una targa controllata. Vedi api-dev/docs/CHECK_SYSTEM_PLAN.md

    /** Preset dei reparti (officina/gommista/carrozzeria) + posizioni gomma. */
    async checkPreset(): Promise<any> {
        try {
            const response = await this.api.get('/check/preset');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Sedi con check aperti, ordinate per data prevista (suggerimenti sotto il selettore sede). */
    async checkSediAperte(params: { count?: number } = {}): Promise<any> {
        try {
            const response = await this.api.get('/check/sedi-aperte', { params });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Elenco testate check. Filtri: codice_sede, stato ('aperta'|'chiusa'), dal, al, count. */
    async checkTestataSearch(params: {
        codice_sede?: string; stato?: string; dal?: string; al?: string; count?: number
    } = {}): Promise<any> {
        try {
            const response = await this.api.get('/check/testata', { params });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Apre un check per la sede. Senza `nuova` riprende quello gia' aperto (meno click
     * per il tecnico); con `nuova: true` ne crea comunque uno nuovo.
     *
     * `pianifica: true` (backoffice) crea invece un check per una data FUTURA:
     * `data_prevista` diventa obbligatoria (`YYYY-MM-DD HH:mm:ss`, mezzanotte = senza orario)
     * e la visita viene datata a quel momento, cosi' il tecnico che arriva in sede quel giorno
     * riprende questo check invece di aprirne un altro.
     */
    async checkTestataStore(body: {
        codice_sede: string; data_prevista?: string | null; note?: string | null;
        nuova?: boolean; pianifica?: boolean; operatore_login?: string | null
    }): Promise<any> {
        try {
            const response = await this.api.post('/check/testata', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Testata con dettagli targa e righe reparto.
     *
     * `silent` sopprime il popup d'errore: serve al ripristino automatico del check
     * all'avvio, dove un check non piu' esistente non e' un errore da mostrare al tecnico.
     */
    async checkTestataShow(id: number | string, silent = false): Promise<any> {
        try {
            const response = await this.api.get(`/check/testata/${id}`);
            return response.data.data;
        } catch (error: any) {
            if (!silent) {
                const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            }
            throw error;
        }
    }

    /**
     * Aggiorna note globali / data prevista della testata (inviare solo i campi modificati).
     * `data_prevista` e' un datetime `YYYY-MM-DD HH:mm:ss`: l'orario e' quello
     * dell'appuntamento e mezzanotte vuol dire "nessun orario indicato".
     */
    async checkTestataUpdate(id: number | string, body: {
        note?: string | null; data_prevista?: string | null; operatore_login?: string
    }): Promise<any> {
        try {
            const response = await this.api.put(`/check/testata/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Elimina una testata con le sue targhe, le righe reparto e gli ALLEGATI.
     *
     * E' l'unico percorso che ripulisce anche le foto: vivono su un'altra connessione
     * (tabella `foto`), quindi non c'e' nessun cascade che le porti via.
     */
    async checkTestataDelete(id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/check/testata/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Targhe della sede della testata, gia' arricchite e ORDINATE dal backend
     * (priorita' > prossima volta > commesse > mai viste): non riordinare lato client.
     *
     * `silent` sopprime il popup d'errore: serve al prefetch (precaricaTarghe), il cui
     * fallimento viene recuperato dalla chiamata normale della lista.
     */
    async checkTarghe(id: number | string, params: { q?: string; sezione?: string; count?: number } = {}, silent = false): Promise<any> {
        try {
            const response = await this.api.get(`/check/testata/${id}/targhe`, { params });
            return response.data.data ?? [];
        } catch (error: any) {
            if (!silent) {
                const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
                Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            }
            throw error;
        }
    }

    /**
     * Segnala su quale targa sta lavorando il tecnico (targa = null quando torna alla
     * lista). Serve anche da heartbeat: la presenza scade da se' lato server.
     * Silenziosa: e' un dato accessorio, un errore non va sbattuto in faccia al tecnico.
     */
    async checkPresenza(id: number | string, targa: string | null): Promise<any> {
        try {
            const response = await this.api.post(`/check/testata/${id}/presenza`, { targa });
            return response.data.data;
        } catch (error: any) {
            return null;
        }
    }

    /** Cerca una targa fuori dalla sede corrente (flusso "non e' qui" -> "Spostala"). */
    async checkTargheCerca(params: { targa: string; codice_sede?: string }): Promise<any> {
        try {
            const response = await this.api.get('/check/targhe/cerca', { params });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Sposta la targa nella sede indicata (cambia l'utilizzatore dell'automezzo). */
    async checkTargaSposta(targa: string, codiceSede: string): Promise<any> {
        try {
            const response = await this.api.post(`/check/targhe/${targa}/sposta`, { codice_sede: codiceSede });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // ── PARCO MEZZI (backoffice) ────────────────────────────────────────────

    /**
     * Elenco targhe per sede + anagrafica delle sedi selezionabili, in una chiamata.
     * Senza `codice_sede` torna il parco di tutte le sedi.
     */
    async parcoMezziGet(params: {
        codice_sede?: string; targa?: string; locatario?: string; intestatario?: string;
        dal?: string; al?: string; solo_lavoro_aperto?: boolean; count?: number;
    } = {}): Promise<any> {
        try {
            const response = await this.api.get('/check/parco-mezzi', { params });
            return response.data.data ?? { righe: [], sedi: [] };
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Stampa PDF dell'elenco filtrato e lo scarica.
     *
     * Si mandano le sole TARGHE a video: i dati li rilegge il server, che è l'unico che
     * può garantirli al cliente a cui il PDF verrà girato.
     */
    async parcoMezziPdf(body: { targhe: string[]; titolo?: string; sottotitolo?: string }): Promise<void> {
        try {
            const response = await this.api.post('/check/parco-mezzi/pdf', body, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'parco-mezzi.pdf';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 30000);
        } catch (error: any) {
            let message = error?.message || 'Errore nella generazione del PDF';
            // responseType blob: un errore JSON del server arriva come Blob, va riletto
            if (error?.response?.data instanceof Blob) {
                try {
                    const testo = JSON.parse(await error.response.data.text());
                    message = testo?.message || testo?.detail || message;
                } catch { /* lascio il messaggio di default */ }
            }
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Storico completo delle commesse della targa (aperte e chiuse), dalla piu' recente.
     * Lista informativa: l'errore non si mostra all'operatore, l'accordion resta vuoto.
     */
    async checkCommesseTarga(targa: string): Promise<any> {
        try {
            const response = await this.api.get(`/check/targa/${targa}/commesse`);
            return response.data.data ?? [];
        } catch (error: any) {
            return [];
        }
    }

    /**
     * Dati del check per una targa: dettaglio salvato (o null), anagrafica veicolo,
     * presenza della foto targa e contesto (check aperti, storico, gomme).
     */
    async checkDettaglioShow(id: number | string, targa: string, params: { reparto?: string } = {}): Promise<any> {
        try {
            const response = await this.api.get(`/check/testata/${id}/dettaglio/${targa}`, { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Salva (upsert) il dettaglio targa e le sue righe reparto.
     * `_updated_at` e' il token di lock ottimistico ricevuto dalla GET: se un altro
     * tecnico ha toccato la stessa targa nel frattempo il backend risponde 409.
     */
    async checkDettaglioSave(id: number | string, targa: string, body: {
        km?: number | null; note?: string | null; reparti?: any[]; _updated_at?: string | null
    }): Promise<any> {
        try {
            const response = await this.api.put(`/check/testata/${id}/dettaglio/${targa}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Corregge il rilievo di una gomma (pratica_deposito_gomme, locazione = 1) dal check.
     * Marca, modello e misura sono per ASSE nel gestionale: la correzione vale anche per
     * la gomma gemella. Risponde con le gomme a bordo ricalcolate.
     */
    async checkGommaRilievo(targa: string, pos: string, body: Record<string, any>): Promise<any> {
        try {
            const response = await this.api.put(`/check/targa/${targa}/gomma/${pos}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Imposta / rimuove la priorita' di una targa (icona cuore) dentro un check.
     * La priorita' e' della testata, non dell'automezzo: il check dopo riparte pulito.
     */
    async checkTargaPriorita(id: number, targa: string, priorita: number): Promise<any> {
        try {
            const response = await this.api.put(`/check/testata/${id}/targa/${targa}/priorita`, { priorita });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Rapportino del check: righe targa + reparto + preset con la sede di accettazione,
     * piu' l'elenco delle sedi selezionabili (arrivano insieme: sono poche e servono
     * comunque al menu a tendina di ogni riga).
     */
    /**
     * Stampa PDF del rapportino (A4 verticale) e la scarica.
     * `chiavi` = righe a video dopo i filtri; omesso = tutto il rapportino.
     */
    async checkRapportinoPdf(id: number | string, chiavi?: string[], nomeFile = 'rapportino.pdf'): Promise<void> {
        try {
            const response = await this.api.post(`/check/testata/${id}/rapportino/pdf`,
                chiavi ? { chiavi } : {}, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = nomeFile;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => URL.revokeObjectURL(url), 30000);
        } catch (error: any) {
            let message = error?.message || 'Errore nella generazione del PDF';
            // responseType blob: un errore JSON del server arriva come Blob, va riletto
            if (error?.response?.data instanceof Blob) {
                try {
                    const testo = JSON.parse(await error.response.data.text());
                    message = testo?.message || testo?.detail || message;
                } catch { /* lascio il messaggio di default */ }
            }
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async checkRapportino(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/check/testata/${id}/rapportino`);
            return response.data.data ?? { righe: [], sedi: [] };
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Sposta una voce del rapportino su un'altra sede di accettazione.
     * Senza `preset` si sposta l'intera riga reparto, con `preset` la singola voce.
     */
    async checkRepartoSedeAccettazione(
        repartoId: number, sedeAccettazione: string, preset: string | null = null,
    ): Promise<any> {
        try {
            const response = await this.api.put(`/check/reparto/${repartoId}/sede-accettazione`, {
                sede_accettazione: sedeAccettazione,
                preset,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Rimanda alla "prossima volta" una voce del rapportino.
     * `preset` identifica la singola voce dentro la riga reparto (null solo per le righe
     * senza preset, dove la voce e' la riga stessa).
     */
    async checkRepartoRimanda(repartoId: number, preset: string | null = null): Promise<any> {
        try {
            const response = await this.api.post(`/check/reparto/${repartoId}/rimanda`, { preset });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Porta nel check corrente una voce "prossima volta" rimandata da un check precedente.
     *
     * La destinazione e' la testata passata qui, non quella di origine: e' cosi' che il
     * lavoro entra nel check di oggi invece di riaprire una visita chiusa. `preset` indica
     * quale voce della riga si promuove (ignorato per il gommista, che si sposta intero).
     */
    async checkCarryOverPromuovi(
        testataId: number,
        targa: string,
        checkRepartoId: number,
        preset: string | null = null,
    ): Promise<any> {
        try {
            const response = await this.api.post(
                `/check/testata/${testataId}/dettaglio/${targa}/promuovi`,
                { check_reparto_id: checkRepartoId, preset },
            );
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Scarta una voce "prossima volta": non serve piu' e non verra' riproposta ai check
     * successivi. La voce resta a DB chiusa, non viene cancellata.
     */
    async checkCarryOverScarta(repartoId: number, preset: string | null = null): Promise<any> {
        try {
            const response = await this.api.post(`/check/reparto/${repartoId}/scarta`, { preset });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // ==================== CHECK VEICOLI - BACKOFFICE ====================
    // Il backoffice lavora sulla VOCE (il singolo preset), non sulla riga reparto: e' li'
    // che vive lo stato di elaborazione. Vedi api-dev/docs/CHECK_BACKOFFICE_PLAN.md

    /**
     * Lista testate per il backoffice, dalla piu' recente.
     * Filtri: codice_sede (la sede = l'utilizzatore), targa, stato ('aperta'|'chiusa'),
     * dal/al su data_check, count.
     */
    async checkBackofficeTestate(params: {
        codice_sede?: string; targa?: string; stato?: string; dal?: string; al?: string; count?: number
    } = {}): Promise<any> {
        try {
            const response = await this.api.get('/check/backoffice/testate', { params });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Il check esploso per il backoffice: targhe, voci con il loro stato di elaborazione e
     * sedi di accettazione selezionabili.
     */
    /** Operatori assegnabili a un check: `{ value: username, label: anagrafica }`. */
    async checkBackofficeOperatori(): Promise<Array<{ value: string; label: string }>> {
        try {
            const response = await this.api.get('/check/backoffice/operatori');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    async checkBackofficeVoci(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/check/backoffice/testata/${id}/voci`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Rimuove una targa dal check, con le sue righe reparto e le sue foto.
     * Non tocca l'anagrafica del veicolo né le note storiche: quelle seguono la targa.
     */
    async checkDettaglioDelete(dettaglioId: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/check/dettaglio/${dettaglioId}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Stacca una targa in un check NUOVO, foto comprese. Il duplicato nasce da elaborare:
     * gli esiti già dati (commesse, chiusure) restano sul check di origine.
     */
    async checkDettaglioDuplica(dettaglioId: number | string): Promise<any> {
        try {
            const response = await this.api.post(`/check/backoffice/dettaglio/${dettaglioId}/duplica`, {});
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Anteprima di cio' che verrebbe creato dalle voci selezionate (`tipo`: commessa |
     * trucklist). **Non scrive nulla**: la risposta porta `simulato: true`, i gruppi che
     * verrebbero creati e le voci scartate col motivo.
     *
     * `sedeLavorazione` e' la filiale che eseguira' i lavori: entra nell'anteprima solo per
     * mostrarla sui gruppi, il raggruppamento non ne dipende.
     */
    async checkGeneraAnteprima(
        tipo: string,
        voci: { check_reparto_id: number; preset: string | null }[],
        sedeLavorazione: string | null = null,
    ): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/genera/anteprima', {
                tipo, voci, sede_lavorazione: sedeLavorazione,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Crea le commesse dalle voci selezionate: una per (targa, reparto, sede accettazione),
     * con dentro tutti i preset di quel gruppo. `sedeLavorazione` e' la filiale che
     * eseguira' i lavori (`_tabop_officina_lavori_codice`) e vale per tutte le commesse del
     * giro; le foto delle voci vengono copiate sulla commessa con type `varie`.
     *
     * `prenotazione` (`YYYY-MM-DD HH:mm:ss`) e' facoltativa e vale anch'essa per tutto il
     * giro: null significa pratica senza appuntamento.
     *
     * ⚠️ Apre pratiche VERE nel gestionale. Ogni gruppo è indipendente: la risposta
     * distingue `creati`, `falliti` e `scartate`, perché un gruppo fallito non annulla gli
     * altri (una pratica già aperta non si può disfare).
     */
    async checkGeneraCommesse(
        voci: { check_reparto_id: number; preset: string | null }[],
        sedeLavorazione: string | null = null,
        prenotazione: string | null = null,
    ): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/genera/commesse', {
                voci, sede_lavorazione: sedeLavorazione, prenotazione,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Crea le commesse dalle voci selezionate (come `checkGeneraCommesse`) e le mette in UNA
     * TruckList: esistente con `trucklist.tracklist_id` (solo bozza/confermata), altrimenti
     * nuova con `utilizzatore_codice` (la sede) e squadra esterna / descrizione facoltative.
     *
     * Su una TruckList esistente con prenotazione vale la sua per tutte le commesse. La
     * risposta e' quella di `checkGeneraCommesse` piu' `trucklist` (null se non nata) e
     * `trucklist_errore`: le commesse restano create anche se la TruckList fallisce.
     *
     * ⚠️ Apre pratiche VERE nel gestionale.
     */
    async checkGeneraTrucklist(
        voci: { check_reparto_id: number; preset: string | null }[],
        sedeLavorazione: string | null,
        prenotazione: string | null,
        trucklist: {
            tracklist_id?: number | null;
            utilizzatore_codice?: string | null;
            squadra_esterna_id?: number | null;
            description?: string | null;
        },
    ): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/genera/trucklist', {
                voci, sede_lavorazione: sedeLavorazione, prenotazione, trucklist,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Chiude forzatamente una voce: l'intervento non serviva. */
    async checkVoceChiudi(repartoId: number, preset: string | null = null): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/voce/chiudi', {
                check_reparto_id: repartoId, preset,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Riporta a "da elaborare" una voce chiusa forzatamente (non una gia' in commessa). */
    async checkVoceRiapri(repartoId: number, preset: string | null = null): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/voce/riapri', {
                check_reparto_id: repartoId, preset,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Sposta una voce fra le due sezioni del reparto.
     * `verso`: 'da_fare' (promuove una "prossima volta") | 'prossima_volta' (rimanda).
     */
    async checkVoceConverti(repartoId: number, verso: string, preset: string | null = null): Promise<any> {
        try {
            const response = await this.api.post('/check/backoffice/voce/converti', {
                check_reparto_id: repartoId, preset, verso,
            });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    // ==================== CALENDARIO ====================

    /**
     * Eventi del calendario nel periodo, per le tipologie richieste (`tipi` separati da
     * virgola: check, commessa, trucklist). Il filtro e' lato server: un mese di commesse
     * non va scaricato per poi nasconderlo con una checkbox.
     * `miei: 1` restringe ai check dell'utente (assegnati o in cui ha lavorato): e' il
     * calendario del tecnico da mobile.
     */
    async calendarioEventi(params: { dal: string; al: string; tipi?: string; miei?: 0 | 1 }): Promise<any> {
        try {
            const response = await this.api.get('/calendario/eventi', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Elenco dei tipi veicolo (_tabop_tipo_veicolo). */
    async tipoVeicoloGet(): Promise<any> {
        try {
            const response = await this.api.get('/tipoveicolo');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Crea un tipo veicolo mancante (il tecnico puo' aggiungerlo dal campo).
     * Se esiste gia' (per codice o descrizione) il backend restituisce quello esistente.
     */
    async tipoVeicoloStore(body: { descrizione: string; codice?: string }): Promise<any> {
        try {
            const response = await this.api.post('/tipoveicolo', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Modifica la descrizione di un tipo veicolo (il codice non si cambia). */
    async tipoVeicoloUpdate(codice: string, body: { descrizione: string }): Promise<any> {
        try {
            const response = await this.api.put(`/tipoveicolo/${encodeURIComponent(codice)}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /** Cancella un tipo veicolo: il backend rifiuta (409) se automezzi o lavori lo usano. */
    async tipoVeicoloDelete(codice: string): Promise<any> {
        try {
            const response = await this.api.delete(`/tipoveicolo/${encodeURIComponent(codice)}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }

    /**
     * Campagne e contratti di servizio della targa dal mirror LinkEntry.
     *
     * `silenzioso` sopprime il popup di errore: serve a chi mostra questi dati come
     * riquadro accessorio (es. il check in officina), dove un mirror non raggiungibile
     * non deve fermare l'operatore con un alert.
     */
    async linkentryGet(targa: string, silenzioso: boolean = false): Promise<any> {
        try {
            const response = await this.api.get(`automezzi/${targa}/linkentry`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            if (!silenzioso) Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API linkentryGet:', error.message);
            throw error;
        }
    }

    /** Storico delle sincronizzazioni LinkEntry, filtrabile per targa e data. */
    async linkentrySyncRunsGet(params: any = {}): Promise<any> {
        try {
            const response = await this.api.get('linkentry/sync-runs', { params });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API linkentrySyncRunsGet:', error.message);
            throw error;
        }
    }

    /** Dettaglio di una singola sincronizzazione LinkEntry. */
    async linkentrySyncRunShow(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`linkentry/sync-runs/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API linkentrySyncRunShow:', error.message);
            throw error;
        }
    }

    /** Stati presenti nello storico sincronizzazioni, per la select dei filtri. */
    async linkentrySyncRunStati(): Promise<any> {
        try {
            const response = await this.api.get('linkentry/sync-runs/stati');
            return response.data.data;
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API linkentrySyncRunStati:', error.message);
            throw error;
        }
    }

    /** Elimina definitivamente una nota storica della targa (diverso da chiuderla). */
    async notecheckDelete(id: number | string): Promise<any> {
        try {
            const response = await this.api.delete(`/notecheck/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            throw error;
        }
    }


    /**
     * Campi e operatori disponibili per il filtro avanzato degli automezzi.
     * La whitelist vive lato API: il builder si costruisce da questa risposta.
     */
    async automezziFilterFieldsGet(): Promise<any> {
        try {
            const response = await this.api.get('automezzi/filtri/campi');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API automezziFilterFieldsGet:', error.message);
            throw error;
        }
    }

    /**
     * Campi e operatori disponibili per il filtro avanzato delle commesse.
     * La whitelist vive lato API: il builder si costruisce da questa risposta.
     */
    async commesseFilterFieldsGet(): Promise<any> {
        try {
            const response = await this.api.get('commesse/filtri/campi');
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API commesseFilterFieldsGet:', error.message);
            throw error;
        }
    }

    /** Tipi utente (tipo_descrizione) selezionabili per la visibilita' aziendale di un filtro. */
    async savedFilterTipiUtenteGet(): Promise<string[]> {
        try {
            const response = await this.api.get('filtri-salvati/tipi-utente');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API savedFilterTipiUtenteGet:', error.message);
            throw error;
        }
    }

    /** Filtri avanzati salvati visibili all'utente loggato (propri + aziendali). */
    async savedFiltersGet(context: string): Promise<any[]> {
        try {
            const response = await this.api.get('filtri-salvati', { params: { context } });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API savedFiltersGet:', error.message);
            throw error;
        }
    }

    async savedFilterCreate(body: any): Promise<any> {
        try {
            const response = await this.api.post('filtri-salvati', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API savedFilterCreate:', error.message);
            throw error;
        }
    }

    async savedFilterUpdate(id: number, body: any): Promise<any> {
        try {
            const response = await this.api.put(`filtri-salvati/${id}`, body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API savedFilterUpdate:', error.message);
            throw error;
        }
    }

    // ---------------------------------------------------------------
    // Menu preferiti (stellina nel menu laterale + tasti rapidi in home)
    // ---------------------------------------------------------------

    /** Preferiti dell'utente loggato, nell'ordine dei tasti rapidi. */
    async menuPreferitiGet(): Promise<any[]> {
        try {
            const response = await this.api.get('menu-preferiti');
            return response.data.data ?? [];
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API menuPreferitiGet:', error.message);
            throw error;
        }
    }

    /** Aggiunge/rimuove una voce dai preferiti; ritorna l'elenco aggiornato. */
    async menuPreferitoToggle(body: { path: string; nome: string; icona?: string | null }): Promise<{ aggiunto: boolean; preferiti: any[] }> {
        try {
            const response = await this.api.post('menu-preferiti/toggle', body);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API menuPreferitoToggle:', error.message);
            throw error;
        }
    }

    async menuPreferitoDelete(id: number): Promise<any[]> {
        try {
            const response = await this.api.delete(`menu-preferiti/${id}`);
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API menuPreferitoDelete:', error.message);
            throw error;
        }
    }

    /** Salva il nuovo ordine dei tasti rapidi (path nell'ordine desiderato). */
    async menuPreferitiReorder(paths: string[]): Promise<any[]> {
        try {
            const response = await this.api.put('menu-preferiti/ordine', { paths });
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.message || error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API menuPreferitiReorder:', error.message);
            throw error;
        }
    }

    // ---------------------------------------------------------------
    // Impostazioni colonne delle tabelle, per utente (componente ColumnManager)
    // ---------------------------------------------------------------
    // Niente Swal qui: una tabella deve aprirsi comunque, al massimo con le colonne
    // di default. L'errore lo mostra il ColumnManager, che sa se l'utente sta
    // guardando (salvataggio) o se la lettura e' avvenuta in sottofondo.

    /** Preferenze salvate per una tabella, o null se l'utente non ne ha mai salvate. */
    async impostazioniColonneGet(chiave: string): Promise<{ key: string; visible: boolean }[] | null> {
        try {
            const response = await this.api.get(`impostazioni-colonne/${encodeURIComponent(chiave)}`);
            return response.data.data ?? null;
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API impostazioniColonneGet:', error.message);
            throw error;
        }
    }

    /** Salva ordine e visibilita' delle colonne di una tabella per l'utente loggato. */
    async impostazioniColonneSave(chiave: string, impostazioni: { key: string; visible: boolean }[]): Promise<{ key: string; visible: boolean }[]> {
        try {
            const response = await this.api.put(`impostazioni-colonne/${encodeURIComponent(chiave)}`, { impostazioni });
            return response.data.data ?? [];
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API impostazioniColonneSave:', error.message);
            throw error;
        }
    }

    /** Cancella le preferenze dell'utente: la tabella torna alle colonne di default. */
    async impostazioniColonneReset(chiave: string): Promise<void> {
        try {
            await this.api.delete(`impostazioni-colonne/${encodeURIComponent(chiave)}`);
        } catch (error: any) {
            console.error('Errore durante la chiamata all\'API impostazioniColonneReset:', error.message);
            throw error;
        }
    }

    async savedFilterDelete(id: number): Promise<any> {
        try {
            const response = await this.api.delete(`filtri-salvati/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API savedFilterDelete:', error.message);
            throw error;
        }
    }

    // ── VISTE (query salvate del gestionale) ─────────────────────────────
    // Vedi api-dev App\Services\Viste\VisteService

    /** Catalogo delle viste: [{id, nome, tipo, gruppo, titolo, num_filtri}]. */
    async visteGet(): Promise<any[]> {
        try {
            const response = await this.api.get('/viste');
            return response.data.data ?? [];
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API visteGet:', error.message);
            throw error;
        }
    }

    /** Filtri da mostrare e colonne del risultato di una vista (non la esegue). */
    async vistaGet(id: number | string): Promise<any> {
        try {
            const response = await this.api.get(`/viste/${id}`);
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API vistaGet:', error.message);
            throw error;
        }
    }

    /**
     * Esegue una vista.
     * `filtri` e' una mappa campo -> valore; per i filtri data il valore e' {da, a}.
     * Le viste sono query pesanti: qui il timeout di default (40s) non basta sempre.
     */
    async vistaEsegui(id: number | string, filtri: Record<string, any> = {}, limite?: number): Promise<any> {
        try {
            const response = await this.api.post(`/viste/${id}/esegui`,
                { filtri, ...(limite ? { limite } : {}) },
                { timeout: 180000 });
            return response.data.data;
        } catch (error: any) {
            const message = error.response?.data?.detail || error.message || 'Errore sconosciuto';
            Swal.fire({ text: message, icon: 'error', confirmButtonText: 'Ok' });
            console.error('Errore durante la chiamata all\'API vistaEsegui:', error.message);
            throw error;
        }
    }

}



// Esporta una singola istanza del servizio
export const apiService = new ApiService();

// Esporta anche la classe per permettere la creazione di istanze multiple se necessario
export default ApiService;

// Puoi aggiungere qui altre funzioni per chiamare altre API

//export { login, checkToken, fetchCommessa };
